import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzRadioModule } from 'ng-zorro-antd/radio';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';

@Component({
  selector: 'app-define-behavior-wizard-intensity-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, NzFormModule, NzRadioModule],
  templateUrl: './define-behavior-wizard-intensity-step.component.html',
  styleUrl: './define-behavior-wizard-intensity-step.component.scss',
})
export class DefineBehaviorWizardIntensityStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviourIntensityList: BehaviourListModel[] = [];
  @Input() showWarningModal!: () => void;
  @Input() handleKeyDown!: (event: KeyboardEvent) => void;
  @Input() trackById!: (index: number, item: { id: number }) => number;
}
